import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sheetClose } from '../../redux/bottomSheetSlice';
import { setSelectedStore } from '../../redux/nearbyStoreSlice';
import './StoreAddress.scss';

const StoreAddress = () => { 
    const dispatch = useDispatch();
    const {nearbyStores} = useSelector((state) => state.nearbyStore);
    const [agentData, setAgentData] = useState(null);
    

    useEffect(() => {
        const storedAgentData = localStorage.getItem('agentData');
        if (storedAgentData) {
            const parsedData = JSON.parse(storedAgentData);
            setAgentData(parsedData);
        }
    }, []);    
    
    const handleStoreSelect = (store_code, storeName) => {  
        const selectedStore = {
            code: store_code,
            name: storeName
        };
        if (selectedStore) {
            dispatch(setSelectedStore(selectedStore));
        }
        dispatch(sheetClose());        
    };
    
  return (
    <div className='storeAddress-wrapper'>
        {agentData ? (
            <div className='storeAddress' onClick={() => handleStoreSelect(agentData.storeCode, agentData.storeName)}>
                <div className="storeAddress-left">
                    <div className='storeAddress--content'>
                        <p className='storeAddress--content-title'>{agentData.storeName}</p>
                        <p className='storeAddress--content-para'>{agentData.storeAddress}</p>
                        {agentData.storePhone && <p className='storeAddress--content-para'>Phone - {agentData.storePhone}</p>}                        
                    </div>
                </div>
            </div>
        ) : (
            <p>No Agent data available</p>
        )}
            
        {nearbyStores.map((store) => (
            <div key={store.store_code} className='storeAddress' onClick={() => handleStoreSelect(store.store_code, store.place_name)}>
                <div className="storeAddress-left">
                    <div className='storeAddress--content'>
                        <p className='storeAddress--content-title'>{store.place_name}</p>
                        <p className='storeAddress--content-para'>{store.address}</p>
                        {store.phone && <p className='storeAddress--content-para'>Phone - {store.phone}</p> }                        
                    </div>
                </div>
            </div>
        ))}
    </div>
  )
}

export default StoreAddress
